{
  "statisticsCommon": {
    "whereAreYou": "Du bist hier"
  }
}
